import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import userRights from "../../components/_utils/userRights";
import { Card, Row, Col, Select, Button, Input, Tooltip, Form, Drawer, notification, Checkbox, Popconfirm, Tabs, DatePicker } from 'antd'
import { TableComp } from 'sz-react-utils'
import Request from '../../request'
import moment from 'moment'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import { FaRupeeSign, FaUserClock, FaSignInAlt, FaUserAstronaut } from "react-icons/fa";
import { RightsWrapper } from '../../components/_utils/utils';
const { MonthPicker } = DatePicker
const { Option } = Select
const TabPane = Tabs.TabPane
let userCheckBox = {}
let accountPaymentCompanies = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies : '';


@Form.create()
class AddSupportStaffSalary extends Component {
  state = {
    visible: true,
    supportStaff: [],
    supportStaffSalary: {},
  }

  loadSupportStaff = async () => {
    let supportStaffReport = await Request.getSupportStaffSalary()
    let supportStaff = []
    supportStaffReport.data.map((user, index) => {
      supportStaff.push({
        _id: user._id,
        display: user.name
      })
    })
    this.setState({ supportStaff: supportStaff })
  }

  getSupportStaffSalary = async (staffId) => {
    let response = await Request.supportStaffSalaryById({ id: staffId })
    this.setState({ supportStaffSalary: response.doc })
    return response.doc
  }



  handleSupportStaffSalarySubmission = (e) => {
    let { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      let { supportStaffSalary } = this.state
      let values = _.clone(valData)
      values.joiningSalary = supportStaffSalary.joiningSalary
      values.name = supportStaffSalary.name
      values.fatherName = supportStaffSalary.fatherName
      values.company = supportStaffSalary.company
      let response = await Request.addSupportStaffSalaryConfirmation(values)
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.props.form.setFieldsValue({ userId: '', staffSalary: '', workingDays: '', attendanceYearMonth: '', confirmationStatus: '' })
      this.onClose()
    })
  }


  componentDidMount() {
    this.loadSupportStaff()
  }

  onClose = () => {
    this.setState({ visible: false, supportStaffSalary: {} })
    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  render() {
    let { form: { getFieldDecorator, setFieldsValue } } = this.props
    let { visible, supportStaff } = this.state
    let supportStaffInput = {
      fields: [
        {
          label: 'Select User',
          key: 'userId',
          type: 'select',
          options: supportStaff,
          required: true,
          onChange: async (v) => {
            setFieldsValue({ userId: v })
            let response = await this.getSupportStaffSalary(v)
            setFieldsValue({ staffSalary: response.staffSalary })
          }
        },
        {
          label: 'Staff Salary',
          type: 'number',
          key: 'staffSalary',
          required: true
        },
        {
          label: 'Staff Working Days',
          type: 'number',
          key: 'workingDays',
          required: true
        },
        {
          label: 'Salary Month',
          type: "month",
          required: true,
          key: 'attendanceYearMonth'
        },
        {
          label: 'Status',
          type: 'select',
          key: 'confirmationStatus',
          required: true,
          options: ['Pending', 'Approved'],
          onChange: v => {
            setFieldsValue({ confirmationStatus: v })
          }
        }
      ]
    }
    return (
      <Drawer
        title="Add Support Staff Salary"
        placement="right"
        closable={true}
        visible={visible}
        width={500}
        onClose={this.onClose}>
        <Form onSubmit={this.handleSupportStaffSalarySubmission}>
          <Card>
            <GetAllFormFields
              inputSchema={supportStaffInput}
              getFieldDecorator={getFieldDecorator} />
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginBottom: 10, marginLeft: '33%' }}
              loading={this.props.loading}>
              SAVE
            </Button>
          </Card>
        </Form>
      </Drawer>
    )
  }
}

export default AddSupportStaffSalary